import { useEffect } from 'react';

export const sortArrayOfObjects = (data: any[], sortKey: string, isDescending: boolean) => {
    if (isDescending) {
        return data.sort((a, b) => (b[sortKey] || 0) - (a[sortKey] || 0));
    }
    return data.sort((a, b) => (a[sortKey] || 0) - (b[sortKey] || 0));
};

export const useOuterClick = (
    ref: React.MutableRefObject<HTMLInputElement | HTMLDivElement>,
    callback: () => void,
    eventType = 'mousedown'
): void => {
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener(eventType, handleClickOutside);
        return () => {
            document.removeEventListener(eventType, handleClickOutside);
        };
    }, [ref, callback, eventType]);
};
